import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=34569acb&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34569acb')) {
      api.createRecord('34569acb', component.options)
    } else {
      api.reload('34569acb', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=34569acb&", function () {
      api.rerender('34569acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xK9BRlRhAyvI/JS/cancellationPolicy.vue"
export default component.exports